import { documents } from 'api';
import { UPLOAD_DOCUMENT } from 'store/actions/documents';

export default {
  [UPLOAD_DOCUMENT]: (params, { container, folder, docType, file }) =>
    new Promise((resolve, reject) => {
      documents
        .uploadDocument({ container, folder, docType, file })
        .then(
          ({ data }) => {
            resolve(data);
          },
          err => {
            reject(err);
          }
        )
        .catch();
    })
};
